/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asterisk (*) for every value, lists like 1,15,30, ranges like 1-5, and steps like */5 or 9-17/2. Named months (jan…dec) and weekdays (sun…sat) work too.`)
};

const es_cr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asterisco (*) para cada valor, listas como 1,15,30, rangos como 1-5, y pasos como */5 o 9-17/2. Los meses nombrados (jan…dec) y días de la semana (sun…sat) también funcionan.`)
};

const de_cr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sternchen (*) für jeden Wert, Listen wie 1,15,30, Bereiche wie 1-5 und Schritte wie */5 oder 9-17/2. Benannte Monate (jan…dec) und Wochentage (sun…sat) funktionieren ebenfalls.`)
};

const nl_cr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sterretje (*) voor elke waarde, lijsten zoals 1,15,30, bereiken zoals 1-5 en stappen zoals */5 of 9-17/2. Benoemde maanden (jan…dec) en weekdagen (sun…sat) werken ook.`)
};

const fr_cr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Astérisque (*) pour chaque valeur, listes comme 1,15,30, plages comme 1-5, et étapes comme */5 ou 9-17/2. Les mois nommés (jan…dec) et les jours de la semaine (sun…sat) fonctionnent aussi.`)
};

const it_cr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asterisco (*) per ogni valore, elenchi come 1,15,30, intervalli come 1-5 e incrementi come */5 o 9-17/2. Funzionano anche i mesi denominati (jan…dec) e i giorni della settimana (sun…sat).`)
};

const pt_br2_cr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asterisco para cada valor, listas como 1,15,30, intervalos como 1-5, e passos como */5 ou 9-17/2. Meses nomeados (jan…dec) e dias da semana (sun…sat) também funcionam.`)
};

const pt_cr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Asterisco (*) para cada valor, listas como 1,15,30, intervalos como 1-5 e passos como */5 ou 9-17/2. Meses nomeados (jan…dez) e dias da semana (dom…sáb) também funcionam.`)
};

const ja_cr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての値に対してアスタリスク(*)、1,15,30のようなリスト、1-5のような範囲、*/5または9-17/2のようなステップ。名前付きの月（jan～dec）と曜日（sun～sat）も動作します。`)
};

const zh_cr_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`星号（*）表示所有取值，还支持像 1,15,30 这样的列表、像 1-5 这样的范围，以及像 */5 或 9-17/2 这样的步长。像 jan 到 dec 这样的月份名称和像 sun 到 sat 这样的星期名称同样适用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_faq2_a", locale)
	if (locale === "en") return en_cr_faq2_a(inputs)
	if (locale === "es") return es_cr_faq2_a(inputs)
	if (locale === "de") return de_cr_faq2_a(inputs)
	if (locale === "nl") return nl_cr_faq2_a(inputs)
	if (locale === "fr") return fr_cr_faq2_a(inputs)
	if (locale === "it") return it_cr_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_cr_faq2_a(inputs)
	if (locale === "pt") return pt_cr_faq2_a(inputs)
	if (locale === "ja") return ja_cr_faq2_a(inputs)
	return zh_cr_faq2_a(inputs)
};